// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"4068":"97888438","7871":"d9704c22"}[chunkId] + ".chunk.css");